import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class AnneeAcademiqueService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification/liste-annee'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getAnneesAcademiques = async () => {
  const response = await axios.get(`${this.API_URL}`);
  return response.data;
};

}


